import { MIN_AMOUNT_OF_PICS } from 'common/utils/conciergeDigitalInvoiceItem.constants'

export const DEFAULT_CURRENCY_CODE = 'USD'

export const DEFAULT_CURRENCY_SYMBOL = '$'

export const DEFAULT_COUNTRY_CODE = 'US'

export const MOSAIC_SIZES = {
  CLASSIC: 25,
  SMALL: 9,
}

export const PRICING = {
  box: {
    base: 39,
  },
  books: {
    base: 75,
    minPages: MIN_AMOUNT_OF_PICS,
    dueBackMonths: 6,
  },
  digital: {
    base: 45,
  },
  virtualGallery: {
    base: 79,
  },
}

// NOTE: Temporary new breakpoints for future layout updates & mui migration
export const BREAKPOINTS = {
  sm: 600, // (same as current MUI sm)
  md: 960, // (same as current MUI md)
  lg: 1280, // (same as current MUI lg)
  xl: 1564,
  xxl: 1920,
}
